import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User } from '../../types';

// Initial state
const initialState: AuthState = {
  user: null,
  token: localStorage.getItem('token'),
  refreshToken: null,
  isAuthenticated: !!localStorage.getItem('token'),
  isLoading: false,
  error: null,
};

// Auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setAuthenticated: (state, action: PayloadAction<{
      isAuthenticated: boolean;
      user?: User | null;
      token?: string | null;
      refreshToken?: string | null;
    }>) => {
      state.isAuthenticated = action.payload.isAuthenticated;

      if (action.payload.user !== undefined) {
        state.user = action.payload.user;
      }

      if (action.payload.token !== undefined) {
        state.token = action.payload.token;
      }

      if (action.payload.refreshToken !== undefined) {
        state.refreshToken = action.payload.refreshToken;
      }

      // Clear error when setting authenticated state
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.error = null;
    }
  }
});

export const { clearError, setAuthenticated, setLoading, setError, clearAuth } = authSlice.actions;
export default authSlice.reducer;
